<template>
    <v-btn
        variant="text"
        color="error"
        height="40"
        class="gst-remove-row-cell text-none"
        name="btn-remove"
        @click="onClickDo"
        @keydown.tab.stop>
        {{ $t('_common:buttons.remove') }}
    </v-btn>
</template>

<script>
/**
 * The Remove cell of a grid of rows not saved yet (the Add a Campaign grids): red text that hands
 * its row to the grid's `context.removeRow`, which takes the row out at once. Tab leaves the button
 * in the browser's order: the grid's own Tab moves from cell to cell, which these grids can't
 * focus, so it would hold the focus on the button.
 */
export default {
    name: 'RemoveRowCellRenderer',
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    methods: {
        onClickDo() {
            this.params.context.removeRow(this.params.data);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';

/*
 * As the Figma Remove (node 8343:9594): a 40px text button with 4px each side of "Remove" in Medium
 * 14px Warning Red (the theme's error colour), so it is only as wide as its text (59px). It is an
 * inline grid, so the cell's own centring places it. Top-aligned, because on the text's baseline it
 * would stretch the cell's 41px line and sit a pixel below the middle of the row.
 */
.gst-remove-row-cell {
    min-width: 0;
    padding: 0 theme-spacing(1);
    vertical-align: top;
    letter-spacing: normal;
    text-indent: 0;
}
</style>
